import { useEffect, useState } from "react";

import { isGoldBotResourceRequestCanceled } from "../services/goldBotResource";

/**
 * Poll one GoldBot endpoint with the same lifecycle the /status and
 * /positions hooks use: abort in flight requests, ignore cancellations, and
 * keep the last error until a request succeeds again.
 */
export function useGoldBotResource(readResource, intervalMs) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isActive = true;
    let activeController = null;

    const load = async () => {
      activeController?.abort();
      const controller = new AbortController();
      activeController = controller;

      try {
        const payload = await readResource({ signal: controller.signal });
        if (isActive) {
          setData(payload);
          setError(null);
        }
      } catch (requestError) {
        if (isActive && !isGoldBotResourceRequestCanceled(requestError)) {
          setError(requestError);
        }
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    load();
    const pollInterval = window.setInterval(load, intervalMs);

    return () => {
      isActive = false;
      window.clearInterval(pollInterval);
      activeController?.abort();
    };
  }, [readResource, intervalMs]);

  return { data, error, isLoading };
}
